import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import {
    DataSourceDtoTypeEnum,
    ColumnDtoTypeEnum,
    OrderByDtoDirectionEnum,
    GroupByDtoDateTruncUnitEnum,
    AggregateOperationDtoAggregateFunctionEnum,
    FilterDtoOperatorEnum,
    FiltersDtoOperatorEnum,
} from '../typescript-axios';

export const useAddDataSourceValidationSchema = () => {
    const { t } = useTranslation();

    const columnSchema = Yup.object({
        table: Yup.string().required(t('validation.required')),
        column: Yup.string().required(t('validation.required')),
        type: Yup.string().oneOf(Object.values(ColumnDtoTypeEnum)).optional(),
    });

    const filterSchema = Yup.object({
        column: columnSchema.required(t('validation.required')),
        operator: Yup.string()
            .oneOf(Object.values(FilterDtoOperatorEnum))
            .required(t('validation.required')),
        value: Yup.mixed().optional(),
    });

    const filtersSchema = Yup.object({
        conditions: Yup.array()
            .of(filterSchema),
        operator: Yup.string()
            .oneOf(Object.values(FiltersDtoOperatorEnum))
            .default(FiltersDtoOperatorEnum.And),
    });

    const aggregateOperationSchema = Yup.object({
        aggregate_function: Yup.string()
            .oneOf(Object.values(AggregateOperationDtoAggregateFunctionEnum))
            .required(t('validation.required')),
        column: columnSchema.required(t('validation.required')),
    });

    const groupBySchema = Yup.object({
        date_trunc_unit: Yup.string()
            .oneOf(Object.values(GroupByDtoDateTruncUnitEnum))
            .optional(),
        aggregate_operations: Yup.array()
            .of(aggregateOperationSchema)
            .optional(),
    });

    const orderBySchema = Yup.object({
        columns: Yup.array()
            .of(columnSchema),
        direction: Yup.string()
            .oneOf(Object.values(OrderByDtoDirectionEnum))
            .default(OrderByDtoDirectionEnum.Asc),
    });

    const queryDefinitionSchema = Yup.object({
        table_source: Yup.array()
            .of(Yup.string().required())
            .min(1, t('validation.atLeastOne'))
            .required(t('validation.required')),
        columns: Yup.array().of(columnSchema).optional(),
        filters: filtersSchema.optional(),
        group_by: groupBySchema.optional(),
        order_by: orderBySchema.optional(),
    });

    return Yup.object({
        dataSource: Yup.object({
            name: Yup.string()
                .required(t('validation.required'))
                .min(1, t('validation.required')),
            type: Yup.string()
                .oneOf(Object.values(DataSourceDtoTypeEnum))
                .required(t('validation.required')),
            query_definition: queryDefinitionSchema.required(
                t('validation.required')
            ),
        }),
    });
};